import { MakecodeProject } from "./makecode-project";
import { ValidationItem } from "./validation-item";

export interface CodingStep {
  hints?: string;
  senseiHelp?: string;
  project?: MakecodeProject;
  validationItems: ValidationItem[];
}
